/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const PickupStoreStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  request: {
    name: 'ขอเบิก',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'อนุมัติเบิก',
    color: 'success',
    icon: 'task_alt',
  },
  reject: {
    name: 'ไม่อนุมัติ',
    color: 'error',
    icon: 'highlight_off_outlined',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default PickupStoreStatus;
